<template>
<div class="back" v-if="show">
  <div class="dialogbox" :style="{
    width: `${width}px`,
    maxHeight: height ? `${height}px` : 'fit-content'
  }">
  <div class="headerBox">
    {{label}}
    <button class="closeBtn" @click="$emit('close')"><iconClose :width="25" :height="25" color="#FFFFFF" backgroundColor="none"/></button>
  </div>
  <div class="content">
    <slot/>
  </div>
  </div>
</div>
</template>

<script>
import iconClose from '../SVG/iconClose'
export default {
  name: 'dialogbox',
  props: ['show', 'width', 'label', 'height'],
  components: {
    iconClose
  }

}
</script>

<style lang="scss">
.dialogbox > div:not(.headerBox) > div:not(.editBox) {
    height: auto;
    display: grid;
    gap: 20px;
}
</style>
<style lang="scss" scoped>
.content {
  height: fit-content;
  min-height: 50px;
}
.back {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 70px;
  right: 0;
  z-index: 200;
  mix-blend-mode: normal;
  backdrop-filter: blur(8px);
  background: rgba(94, 94, 94, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.headerBox {
  width: 100%;
  height: 55px;
  background-color: var(--color-checked);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 27px;
  box-sizing: border-box;
  position: relative;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0.1em;
  border-radius: 10px 10px 0 0;

  color: #FFFFFF;
  gap: 14px;
}
.closeBtn {
  padding: 0;
  margin: 0;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: transparent;
  border: none;
  z-index: 91;
  width: 25px;
  height: 25px;
}
.dialogbox {
  border-radius: 10px;
  &::before {
    display: none!important;
  }
  padding: 0!important;
  margin: 0!important;
  height: fit-content;
  min-width: 481px;
  position: relative;
  background-color: #FFFFFF;
  z-index: 90;
  box-shadow: -4px 0px 15px rgba(0, 0, 0, 0.25);
  &>div:not(.headerBox) {
    border-radius: 10px;
    margin: 0!important;
    position: relative;
    max-width: calc(100% - 54px);
    max-height: calc(100% - 110px);
    background-color: #FFFFFF;
    margin-right: 10px;
    padding-right: 16px;
    padding-left: 29px;
    padding-block: 4px;
    display: block;
    flex-direction: column;
    gap: 20px;
    &>div {
      background-color: #FFFFFF;
      height: auto;
      display: grid;
      margin-block: 40px;
      margin-inline: 20px;
      padding-inline: 20px;
    }
  }
}
</style>
